// Angular imports
import { Injector, OnInit } from '@angular/core';

// 3rd party imports
import { Column } from 'devextreme/ui/data_grid';

// CC-Common imports
import { IconConstants } from 'cc-common';

// Component imports
import { UserPortfolioBaseComponent } from './user-portfolio-base.component';

// Service imports
import { SharedWidgetsService } from '../../shared-widgets-module/_services/shared-widgets.service';
import { UserCommunitiesService } from '../_services/user-communities.service';

// Model imports
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { UserContextTreeResultDto } from '../../_models/user-context-tree-result-dto';
import { UserCommunitiesParametersDto } from '../_models/user-communities/user-communities-parameters-dto';
import { UserDashboardProxyListResultDto } from '../../shared-widgets-module/_models/user-dashboard-proxy-list-result-dto';

export abstract class UserCommunitiesBaseComponent extends UserPortfolioBaseComponent implements OnInit {
    iconCheck = IconConstants.CHECK;
    iconCross = IconConstants.CROSS;
    iconWarn = IconConstants.WARN;
    iconView = IconConstants.VIEW;

    iconProduction = IconConstants.PRODUCTION;
    iconTransition = IconConstants.IN_TRANSITION;
    iconTerminate = IconConstants.TERMINATE;
    iconExclamatory = IconConstants.EXCLAMATION_CIRCLE;

    accessOptions: KeyValueResultDto[];
    userColumns: Column[];
    userList: UserDashboardProxyListResultDto[];
    filterParams: UserCommunitiesParametersDto;

    popoverTarget: string;
    popoverVisible: boolean;
    popoverContent: string;

    constructor(
        protected readonly injector: Injector,
        protected readonly sharedWidgetService: SharedWidgetsService,
        protected readonly communitiesService: UserCommunitiesService
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.accessOptions = [
            { key: false, displayText: 'Show Active Communities' },
            { key: true, displayText: 'Show All Communities' }
        ];
        this.userColumns = this.getUserColumns();
        this.populateUsers();
    }

    onUserSelection(e: any): void {
        let selectedUserId = this.userService.getCurrentUserId();
        if (!!e.selectedRow && e.selectedRow.length > 0) {
            selectedUserId = (e.selectedRow[0] as UserDashboardProxyListResultDto).userId;
        }
        if (this.filterParams.userId !== selectedUserId) {
            this.filterParams.userId = selectedUserId;
            this.doRefresh(false);
        }
    }

    onLocationsSelection(rows: UserContextTreeResultDto[]): void {
        this.filterParams.locationIds = [];
        if (!!rows && rows.length) {
            this.filterParams.locationIds = rows.map((r) => r.locationId);
        }
        this.doRefresh(false);
    }

    onCommunitiesSelection(rows: UserContextTreeResultDto[]): void {
        this.filterParams.communityIds = [];
        if (!!rows && rows.length) {
            this.filterParams.communityIds = rows.map((r) => r.id);
        }
        this.doRefresh(false);
    }

    abstract doRefresh(clearCache: boolean): void;

    private populateUsers(): void {
        this.portfolioHelper.showLoading();
        this.sharedWidgetService.getUserDashboardUsers().subscribe(
            (results) => {
                this.userList = results;
                this.portfolioHelper.hideLoading();
                this.populateCommunities();
            },
            (error) => {
                this.errorService.displayError(error);
                this.portfolioHelper.hideLoading();
            }
        );
    }

    private populateCommunities(): void {
        const params = new UserCommunitiesParametersDto();
        params.includeInactive = false;
        params.userId = this.userService.getCurrentUserId();
        params.communityIds = [];
        params.locationIds = [];
        this.filterParams = params;
        this.doRefresh(false);
    }

    private getUserColumns(): Column[] {
        return [
            {
                dataField: 'name',
                dataType: 'string',
                caption: 'Name'
            },
            {
                dataField: 'title',
                dataType: 'string',
                caption: 'Title'
            },
            {
                dataField: 'managementCompany',
                dataType: 'string',
                caption: 'Management Company'
            },
            {
                dataField: 'location',
                dataType: 'string',
                caption: 'Location'
            }
        ];
    }
}
